import React from 'react';

function useSplashScreen(removeOnMount: boolean = true) {
  const removeSplashScreen = () => {
    const el = document.getElementById('splash-screen');
    if (el) {
      el.remove();
    }
  };
  React.useEffect(() => {
    if (removeOnMount) {
      setTimeout(() => {
        removeSplashScreen();
      }, 1000);
    }
  }, [removeOnMount]);

  return {
    removeSplashScreen
  };
}

export default useSplashScreen;
